/* 130R — carro e motor em toda conversa de WhatsApp com a loja (Tema 2, 19/10/2026, agente veiculo-motor).
   Aprovado pelo Marcus em 19/10/2026: "No final do dia a interação do cliente com o whatsapp é mais importante do que ele
   descobrir sozinho". O vendedor recebe o carro que o cliente salvou no "Meu carro" (localStorage r130_garage), com o motor.

   COMO ENTRA: o assets/r130-chassi.js chama window.R130CarroWa.completar(texto) no mesmo ponto em que acrescenta o chassi
   (clique em link wa.me da loja, window.open dos apps e o painel do chassi). Só no número da loja; sem este arquivo, nada muda.
   REGRAS de completar(texto), sem duplicar (rodar de novo não muda nada):
     1. Campo do carro em branco ("Carro:", "Meu carro (modelo e ano):", "Ano/Modelo do meu carro:"): preenche.
     2. Mensagem que já cita o modelo salvo (card da home, kits, produto): não repete o carro; completa só o motor, logo
        depois do carro ("Meu carro: Hyundai Tucson 2010, motor 2.0") ou na linha "Motor:".
     3. Linha "Motor:" em branco (perguntas guiadas dos kits): preenche; o carro entra numa linha "Carro:".
     4. Senão, acrescenta "Carro: Hyundai Tucson 2010, motor 2.0" antes da linha do campo do chassi, ou no fim.
     Sem motor e sem chassi: "motor não informado". Com o chassi e sem o motor: só o carro (o motor sai do chassi).
   EXCEÇÃO (Marcus, 19/10/2026): mensagem de empresa (oficina ou loja de autopeças, compra como empresa, CNPJ) e toda a
   landing das oficinas (/pages/oficinas-e-lojas) não levam o carro: oficina pergunta por vários carros. O chassi segue
   a regra de sempre do r130-chassi.js.
   Marca <html data-r130-carro-wa> (o convite "Qual é o seu carro?" passa a dizer que o vendedor recebe o carro e o motor).
   Funções puras testadas em node (tests/test_site_motor_js.py): module.exports. */
(function (raiz) {
  'use strict';

  function semAcento(s) { return String(s == null ? '' : s).normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function norm(s) { return semAcento(s).toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim(); }
  function nomeModelo(nome) {
    return String(nome || '').split(' ').map(function (p) {
      if (/\d/.test(p)) return /^I[X]?\d/.test(p) ? p.toLowerCase() : p;
      if (/^[B-DF-HJ-NP-TV-Z]{1,2}$/.test(p)) return p;
      return p.split('-').map(function (q) { return q.charAt(0).toUpperCase() + q.slice(1).toLowerCase(); }).join('-');
    }).join(' ');
  }
  function nomeMontadora(b) {
    b = String(b || '');
    if (/^(BMW|MINI|JAC|VW|GM)$/i.test(b)) return b.toUpperCase();
    return b.split(/([ -])/).map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); }).join('');
  }
  function rotuloCarro(c) { return [nomeMontadora(c.brand), nomeModelo(c.model), c.year || ''].filter(Boolean).join(' '); }
  function cilindrada(t) { var r = /(\d)\s*[.,]\s*(\d)/.exec(String(t || '')); return r ? r[1] + '.' + r[2] : ''; }
  // O texto cita o motor? (pela cilindrada: "3.3 V6" = "3,3"; elétrico pela palavra)
  function citaMotor(texto, motor) {
    var c = cilindrada(motor);
    if (c) return new RegExp('(^|[^0-9])' + c.replace('.', '[.,]') + '(?![0-9])').test(String(texto || ''));
    return !!motor && norm(texto).indexOf(norm(motor)) !== -1;
  }
  function citaModelo(texto, c) {
    var m = norm(c.model);
    return !!m && (' ' + norm(texto) + ' ').indexOf(' ' + m + ' ') !== -1;
  }
  function inserir(t, linha) {
    // Antes da linha do campo do chassi ("Chassi:", "Modelo, ano e chassi:", "Número do Chassi ou Placa:"), se ela não for
    // a primeira (aí a mensagem é uma linha só e o carro vai no fim); senão no fim, depois de uma linha em branco.
    var re = /^[^\n]*chassi[^:\n]*:[ \t]*$/im;
    var m = re.exec(t);
    if (m && m.index > 0) return t.slice(0, m.index) + linha + '\n' + t.slice(m.index);
    t = t.replace(/\s+$/, '');
    return t ? t + '\n\n' + linha : linha;
  }
  function trocar(t, m, novo) { return t.slice(0, m.index) + novo + t.slice(m.index + m[0].length); }

  // Mensagem de empresa: não leva o carro do "Meu carro".
  var EMPRESA = /oficina ou loja de autope[cç]as|comprar como empresa|\bCNPJ\b|lista de pe[cç]as para or[cç]amento/i;
  function ehEmpresa(t) { return EMPRESA.test(String(t || '')); }

  // texto da mensagem + carro salvo ({brand, model, year, motor}) + se há chassi salvo → texto completo.
  function completarCom(t, c, temChassi) {
    t = String(t == null ? '' : t);
    if (!c || !c.brand || !c.model || ehEmpresa(t)) return t;
    var nome = rotuloCarro(c);
    var motorDado = c.motor || (temChassi ? '' : 'não informado');   // com o chassi, o motor sai dele
    var linhaCarro = nome + (motorDado ? ', motor ' + motorDado : '');
    // 1. Campo do carro em branco: rótulo que termina em "carro"/"veículo" ("Carro:", "Meu carro (modelo e ano):",
    //    "Ano/Modelo do meu carro:"). "Modelo, ano e chassi:" é do chassi.
    var vazio = /^([^\n:]*\b(?:carro|ve[ií]culo)(?: \([^)\n]*\))?):[ \t]*$/im.exec(t);
    if (vazio) return trocar(t, vazio, vazio[1] + ': ' + linhaCarro);
    var mm = /^([ \t]*motor[ \t]*):[ \t]*([^\n]*)$/im.exec(t);
    // 2. A mensagem já cita o carro salvo: não repete; só completa o motor.
    if (citaModelo(t, c)) {
      if (mm) return mm[2].trim() || !motorDado ? t : trocar(t, mm, mm[1] + ': ' + motorDado);
      if (!motorDado || /motor n[aã]o informado/i.test(t)) return t;
      // Rótulos "…carro:" na mensagem; o valor de cada um vai até o próximo rótulo ou o fim da linha.
      var reSeg = /\b(?:carro|ve[ií]culo)(?: \([^)\n]*\))?:[ \t]*/gi, s, rot = [], alvo = null;
      while ((s = reSeg.exec(t))) rot.push([s.index, s.index + s[0].length]);
      rot.forEach(function (r, i) {
        var fimLinha = t.indexOf('\n', r[1]);
        var fim = Math.min(fimLinha < 0 ? t.length : fimLinha, i + 1 < rot.length ? rot[i + 1][0] : t.length);
        var valor = t.slice(r[1], fim);
        if (citaModelo(valor, c)) alvo = { valor: valor, fim: fim };
      });
      if (alvo) {   // "Meu carro: Hyundai Tucson 2010." → "Meu carro: Hyundai Tucson 2010, motor 2.0."
        if (c.motor && citaMotor(alvo.valor, c.motor)) return t;
        var pont = /[.*\s]+$/.exec(alvo.valor);
        var corte = pont ? alvo.fim - pont[0].length : alvo.fim;
        return t.slice(0, corte) + ', motor ' + motorDado + t.slice(corte);
      }
      if (c.motor && citaMotor(t, c.motor)) return t;
      return inserir(t, 'Motor: ' + motorDado);
    }
    // 3. Linha "Motor:" (perguntas guiadas): preenche se estiver em branco; o carro entra sem repetir o motor.
    if (mm) {
      if (!mm[2].trim() && motorDado) t = trocar(t, mm, mm[1] + ': ' + motorDado);
      return inserir(t, 'Carro: ' + nome);
    }
    // 4. Linha nova.
    return inserir(t, 'Carro: ' + linhaCarro);
  }

  var puro = { completarCom: completarCom, rotuloCarro: rotuloCarro, citaMotor: citaMotor, ehEmpresa: ehEmpresa };
  if (typeof module !== 'undefined' && module.exports) { module.exports = puro; return; }

  function lsJson(k) { try { return JSON.parse(raiz.localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function carro() { var c = lsJson('r130_garage'); return c && c.brand && c.model ? c : null; }
  function temChassi() { var v = lsJson('r130_chassi'); return !!(v && /^[A-HJ-NPR-Z0-9]{17}$/.test(v.vin || '')); }

  // Landing das oficinas (molde page.oficinas): nenhuma mensagem leva o carro.
  function paginaDeEmpresa() {
    var b = raiz.document.body;
    return /^\/pages\/oficinas-e-lojas\/?$/.test(raiz.location.pathname)
      || !!(b && b.getAttribute('data-template') === 'page' && b.getAttribute('data-suffix') === 'oficinas');
  }
  raiz.R130CarroWa = {
    completar: function (t) { try { return paginaDeEmpresa() ? t : completarCom(t, carro(), temChassi()); } catch (e) { return t; } },
    puro: puro
  };
  try { raiz.document.documentElement.setAttribute('data-r130-carro-wa', ''); } catch (e) {}
})(typeof window !== 'undefined' ? window : this);
